import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentHYCSDocumentVerificationCompleteData,
  type EnrollmentHYCSDocumentVerificationCompleteSubmitOutput,
} from '../../../../models'

export const getEnrollmentHYCSDocumentVerificationCompleteDataMock: EnrollmentHYCSDocumentVerificationCompleteData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/document-verification-complete',
}

export const submitEnrollmentHYCSDocumentVerificationCompleteDataMock: EnrollmentHYCSDocumentVerificationCompleteSubmitOutput =
  {
    __typename: 'SubmitEnrollmentSuccess',
    path: '/enrollment/hycs/welcome',
  }

export const mockGetEnrollmentHYCSDocumentVerificationCompleteData = graphql.mutation(
  'getEnrollmentHYCSDocumentVerificationCompleteData',
  () => {
    return HttpResponse.json({
      data: {
        submitEnrollment: getEnrollmentHYCSDocumentVerificationCompleteDataMock,
      },
    })
  },
)

export const mockSubmitEnrollmentHYCSDocumentVerificationCompleteData = graphql.mutation(
  'submitEnrollmentHYCSDocumentVerificationCompleteData',
  () => {
    return HttpResponse.json({
      data: {
        submitEnrollment: submitEnrollmentHYCSDocumentVerificationCompleteDataMock,
      },
    })
  },
)

export const mockEnrollmentHYCSDocumentVerificationComplete = [
  mockGetEnrollmentHYCSDocumentVerificationCompleteData,
  mockSubmitEnrollmentHYCSDocumentVerificationCompleteData,
]
